import { ReplaySubject } from 'rxjs';
import { BaseModel } from '../../../../../core/_base/crud';
import { ProductStatus } from '../../../../../shared/enums/product-status.enum';
export class NguyenLieuModel extends BaseModel {
	Id_HH: number
	Id_NhomHH: number
	MaHH: string
	TenHH: string
	TenNhomHH: string
	GhiChu: string
	Disable: boolean
	TenNguoiTao: string
	NguoiTao: number
	NgayTao: string
	NguoiSua: number
	NgaySua: string
	TonKhoToiThieu: string
	DungSaiChoPhepNhap: string
	QuyCachDongGoi: string
	DieuKienBaoQuan: string
	TonKhoToiDa: string
	ThoiHanSuDung: number
	DVT1: number
	DVT2: number
	DVT3: number
	QuyDoiDVT2: string
	QuyDoiDVT3: string
	DVTThongKeTon:number
	HinhDaiDien: string
	BoPhanKiemTra: number
	TenBoPhanKiemTra: string
	BoPhanGiamSat: number
	TenBoPhanGiamSat: string
	domain: string
	listKH: any[]
	listNCC: any[]
	listLinkImage: ListImageModel[]
	CanPhieuKt: boolean
	KhoMacDinh: string
	Id_LHH: string
	TenFileGoc: string
	FileImport: FileImportHH
	fileTmpDownLoad: any
	File_TieuChuan: number;
	listNCC_MOQ: NCC_MOQ[]
  Status: number;

	clear() {
		this.Id_HH = 0;
		this.Id_NhomHH = 0;
		this.MaHH = '';
		this.TenHH = '';
		this.TenNhomHH = '';
		this.GhiChu = '';
		this.Disable = false;
		this.TenNguoiTao = '';
		this.NguoiTao = 0;
		this.NgayTao = '';
		this.NguoiSua = 0;
		this.NgaySua = '';
		this.TonKhoToiThieu = '0.00';
		this.DungSaiChoPhepNhap = '0.00';
		this.QuyCachDongGoi = '';
		this.DieuKienBaoQuan = '';
		this.TonKhoToiDa = '0.00';
		this.DVT1 = 0;
		this.DVT2 = 0;
		this.DVT3 = 0;
		this.QuyDoiDVT2 = '0.00000';
		this.QuyDoiDVT3 = '0.00000';
		this.DVTThongKeTon = 0;
		this.HinhDaiDien = '';
		this.BoPhanKiemTra = 0;
		this.BoPhanGiamSat = 0;
		this.ThoiHanSuDung = 0;
		this.TenBoPhanKiemTra = '';
		this.TenBoPhanGiamSat = '';
		this.domain = '';
		this.listLinkImage = [];
		this.listNCC = [];
		this.listKH = [];
		this.CanPhieuKt = false;
		this.KhoMacDinh = '';
		this.Id_LHH = '';
		this.TenFileGoc = '';
		this.FileImport = new FileImportHH();
		this.File_TieuChuan = 0;
		this.listNCC_MOQ = [];
    this.Status = ProductStatus.Active;
	}
	copy(item: NguyenLieuModel) {
		this.Id_HH = item.Id_HH;
		this.Id_NhomHH = item.Id_NhomHH;
		this.MaHH = item.MaHH;
		this.TenHH = item.TenHH;
		this.TenNhomHH = item.TenNhomHH;
		this.GhiChu = item.GhiChu;
		this.Disable = item.Disable;
		this.TenNguoiTao = item.TenNguoiTao;
		this.NguoiTao = item.NguoiTao;
		this.NgayTao = item.NgayTao;
		this.NguoiSua = item.NguoiSua;
		this.NgaySua = item.NgaySua;
		this.TonKhoToiThieu = item.TonKhoToiThieu;
		this.DungSaiChoPhepNhap = item.DungSaiChoPhepNhap;
		this.QuyCachDongGoi = item.QuyCachDongGoi;
		this.DieuKienBaoQuan = item.DieuKienBaoQuan;
		this.TonKhoToiDa = item.TonKhoToiDa;
		this.DVT1 = item.DVT1;
		this.DVT2 = item.DVT2;
		this.DVT3 = item.DVT3;
		this.QuyDoiDVT2 = item.QuyDoiDVT2;
		this.QuyDoiDVT3 = item.QuyDoiDVT3;
		this.HinhDaiDien = item.HinhDaiDien;
		this.BoPhanKiemTra = item.BoPhanKiemTra;
		this.TenBoPhanKiemTra = item.TenBoPhanKiemTra;
		this.BoPhanGiamSat = item.BoPhanGiamSat;
		this.TenBoPhanGiamSat = item.TenBoPhanGiamSat
		this.ThoiHanSuDung = item.ThoiHanSuDung;
		this.domain = item.domain;
		this.listLinkImage = item.listLinkImage;
		this.listNCC = item.listNCC;
		this.listKH = item.listKH;
		this.CanPhieuKt = false;
		this.KhoMacDinh = item.KhoMacDinh;
		this.Id_LHH = item.Id_LHH;
		this.TenFileGoc = item.TenFileGoc;
		this.File_TieuChuan = item.File_TieuChuan;
		if (item.FileImport != null) {
			this.FileImport = new FileImportHH();
			this.FileImport.copy(item.FileImport);
		}
		else {
			this.FileImport = new FileImportHH();
			this.FileImport.clear();
		}
		this.listNCC_MOQ = item.listNCC_MOQ;
	}
}
export class ListImageModel extends BaseModel {
	strBase64: string
	filename: string
	type: string
	src: string
	IsAdd: boolean
	IsDel: boolean
	IsImagePresent: boolean
	clear() {
		this.strBase64 = '';
		this.filename = '';
		this.type = '';
		this.src = '';
		this.IsAdd = false;
		this.IsDel = false;
		this.IsImagePresent = false;
	}
	copy(item: ListImageModel) {
		this.strBase64 = item.strBase64;
		this.filename = item.filename;
		this.type = item.type;
		this.src = item.src;
		this.IsAdd = item.IsAdd;
		this.IsDel = item.IsDel;
		this.IsImagePresent = item.IsImagePresent;
	}
}
export class FileImportHH extends BaseModel {
	idLoaiHH: number;
	base64: string;
	fileByte: any;
	filename: string;
	dienGiai: string;
	extension: string;

	clear() {
		this.idLoaiHH = 0;
		this.base64 = '';
		this.fileByte = null;
		this.filename = '';
		this.dienGiai = '';
		this.extension = '';
	}

	copy(item: FileImportHH) {
		this.idLoaiHH = item.idLoaiHH;
		this.base64 = item.base64;
		this.fileByte = item.fileByte;
		this.filename = item.filename;
		this.dienGiai = item.dienGiai;
		this.extension = item.extension;
	}
}
export class NCC_MOQ extends BaseModel {
	IdNCC: number
	MaNCC: string
	MOQ: number
	MOQ_dvt: number
	LeadTime: number
	arrayIdDvt: any[]
	filteredDVT_MOQ: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	DVT_MOQFilterCtrl: string = '';

	clear() {
		this.IdNCC = 0;
		this.MaNCC = "";
		this.MOQ = 0;
		this.MOQ_dvt = 0;
		this.LeadTime = 0;
		this.arrayIdDvt = [];
		this.filteredDVT_MOQ.next(this.arrayIdDvt.slice());
	}
}
